// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NqjT","content":"styles_content__38cZL","small":"styles_small__17CS-","fullWidth":"styles_fullWidth__27KXL","noTopNavigation":"styles_noTopNavigation__3he2O"};